<template>
  <div :style="backgroundDivStyle">
    <v-btn
      class="KoioteButtonFeedback"
      :style="buttonStyle"
      @click="click"
      >{{ input.customized?.label }}</v-btn
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "KoioteButtonFeedback",

  props: {
    input: Object,
  },

  computed: {
    backgroundDivStyle() {
      return {
        backgroundColor: this.retrievedColor,
        width: "100%",
        height: "100%",
        position: "absolute",
        alignContent: "center",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
        borderRadius: "5px",
      };
    },

    buttonStyle() {
      return {
        backgroundColor: this.input.customized.background_color,
        color: this.input.customized.foreground_color,
        border: "1px solid " + this.input.customized.border_color,
        width: "90%",
        height: "70%",
        textAlign: "center",
        whiteSpace: "break-spaces",
        lineHeight: "normal",
        fontSize: "small",
      };
    },

    write_topic() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized?.topic_write;
    },

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized?.vartable;
    },

    value() {
      const retrievedValue = this.vartable?.find(
        (v) => v.formatted_address == this.input.customized.read_address
      )?.value;
      return retrievedValue == null || isNaN(retrievedValue) ? 0 : retrievedValue;
    },

    retrievedColor() {
      return this.value ? this.input.customized.feedback_true_color : this.input.customized.feedback_false_color;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions("nodered", ["doPublish"]),

    click() {
      console.log("click");
      const rawAddress = this.vartable.find((v) => v.formatted_address == this.input.customized.write_address)?.address;
      console.log(rawAddress, this.write_topic, {
        type: this.input.customized.datatype,
        value: this.input.customized.write_value,
      });

      if (rawAddress)
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: rawAddress,
            value: this.input.customized.write_value,
          },
        });
    },
  },
};
</script>

<style>
.KoioteButtonFeedback {
  font-size: 1vw;
}

@media (orientation: portrait) {
  .KoioteButtonFeedback {
    font-size: 1.3vw;
  }
}

@media (orientation: landscape) and (max-width: 600px) {
  .KoioteButtonFeedback {
    font-size: 0.85vw;
  }
}

@media (orientation: portrait) and (max-width: 500px) {
  .KoioteButtonFeedback {
    font-size: 1.55vw;
  }
}
</style>
